// Services
import {
  getOCRCustomerDataService,
  saveDifferentDataDecisionService,
} from '../services/upload-id-different-data.services';
// Types
import {
  UploadIdDifferentDataCustomerApiParamsType,
  UploadIdDifferentDataCustomerApiResponseType,
} from '../types/upload-id-different-data-customer-api-response.type';
// Utilities
import { customerDataFromOCRIsValid } from './utils/upload-id-different-data.resolver.utils';
import { requestRespondedNoContent } from '@openbank/cf-ui-framework';

const getOCRCustomerDataResolver = async (
  ocrValidationId: string
): Promise<[UploadIdDifferentDataCustomerApiResponseType] | [null, boolean]> => {
  const [response] = await getOCRCustomerDataService(ocrValidationId);

  return customerDataFromOCRIsValid(response) ? [response] : [null, true];
};

const saveDifferentDataDecisionResolver = async (
  props: UploadIdDifferentDataCustomerApiParamsType
): Promise<[true] | [null, boolean]> => {
  const [, { status }] = await saveDifferentDataDecisionService(props);

  return requestRespondedNoContent(status) ? [true] : [null, true];
};

export { getOCRCustomerDataResolver, saveDifferentDataDecisionResolver };
